<template>
  <el-container class="clue-pool">
    <el-header class="header-style">
      <el-divider content-position="left">外地线索</el-divider>
      <el-row class="mb-10">
        <el-col :span="7" style="display: flex">
          <div class="level count_style" v-if="false">
            <span class="count">等级：</span>
            <img :src="img" alt="" />
            <span class="count">{{ vipName }}</span>
            <i class="el-icon-question" @click="dialogVisible = true"></i>
          </div>
          <div class="level_num count_style">
            <span class="count">线索总数：{{ count }}</span>
            <span v-if="false" style="padding-left: 0.4rem" class="count">已领取：{{ vipData.user_thread_row }}/{{
          vipData.store_space }}</span>
          </div>
        </el-col>
        <el-col v-if="false" :span="6" class="search_position">
          <el-input prefix-icon="el-icon-search search" v-model="search" size="mini" placeholder="输入客户姓名或客户手机号搜索" />
        </el-col>
        <!--      <el-col :span="4"   class="tr m-label">选择导出时间</el-col>-->
        <el-col :span="5" v-if="pageNodes.indexOf('导出') !== -1">
          <div>
            <el-date-picker v-model="values" type="daterange" range-separator="至" size="mini" format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd" @change="pickerDataChange2" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="ysyTypeInPickerOptions">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6" v-if="pageNodes.indexOf('导出') !== -1">
          <el-select v-model="value2" multiple collapse-tags size="mini" @change="selectExport"
            style="margin-left: 20px" placeholder="请选择导出条件">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="tr">
          <el-button type="primary" size="mini" @click="handleAddAllot">分配线索</el-button>
          <el-button v-if="false" type="primary" size="mini" @click="handleAddOpen">录入线索</el-button>
          <el-button v-if="false" type="primary" @click="dialogVisible3 = true" plain size="mini">导入</el-button>
          <el-button v-if="pageNodes.indexOf('导出') !== -1" style="margin-left: 0.1rem" type="primary" plain size="mini"
            @click="handleExport">导出</el-button>
        </el-col>
      </el-row>
      <el-collapse @change="handleChangeHeight" v-model="activeOpen">
        <el-collapse-item title="高级筛选" name="1">
          <div class="changeHeight m-tabs-content">
            <el-row type="flex">
              <el-col :span="2" class="tr m-label text_right">群聊ID</el-col>
              <el-col :span="4">
                <el-input @change="groupInput" v-model="highSearch.group_chat_id" size="mini" placeholder="输入群聊ID" />
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">IM人员</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.im_name" placeholder="请选择IM人员"
                  size="mini" clearable>
                  <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">咨询分类</el-col>
              <el-col :span="4">
                <el-select multiple collapse-tags v-model="highSearch.refer_cate" placeholder="请选择咨询分类"
                  @change="selectType" size="mini" clearable>
                  <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="false" :span="2" class="tr m-label text_right">所属省市</el-col>
              <el-col v-if="false" :span="4">
                <el-cascader ref="cascaderAddr" style="width: 100%" v-model="value3" :props="optionProps"
                  :options="options" size="mini" @change="handleChangeSearch"></el-cascader>
              </el-col>
              <el-col :span="2" class="tr m-label text_right">录入时间</el-col>
              <el-col :span="4">
                <div class="block">
                  <el-date-picker v-model="value1" :picker-options="ysyTypeInPickerOptions" type="daterange"
                    range-separator="至" size="mini" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
                    @change="pickerDataChange" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2" v-if="false" :offset="3" class="tr m-label text_right">选择园区</el-col>
              <el-col :span="4" v-if="false">
                <el-select multiple collapse-tags v-model="highSearch.garden" placeholder="请选择园区" @change="selectType"
                  size="mini" clearable>
                  <el-option v-for="item in options4" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="14" style="text-align: center">
                <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 306px)" :data="CluesPool" size="medium" style="width: 100%"
        @selection-change="handleSelectionChange" border>
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column v-if="false" fixed label="ID" prop="thread_id"></el-table-column>
        <el-table-column class="el-status" fixed label="线索状态" prop="status">
          <template slot-scope="scope">
            <span class="el-position"><span class="dot" :style="{
          background:
            scope.row.status === 0
              ? '#88D023'
              : '' || scope.row.status === 1
                ? '#88D023'
                : '' || scope.row.status === 2
                  ? '#CCCCCC'
                  : '' || scope.row.status === 3
                    ? '#D02323'
                    : '',
        }">
              </span>
              {{
          scope.row.status == 0
            ? "未认领"
            : "" || scope.row.status == 1
              ? "跟踪中"
              : "" || scope.row.status == 2
                ? "已成交"
                : "" || scope.row.status == 3
                  ? "无法联系"
                  : ""
        }}
            </span>
          </template>
        </el-table-column>
        <el-table-column class="omit" width="140" label="录入时间" prop="created_at">
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.created_at" placement="top">
              <span class="count_style" style="display: inherit">{{
                scope.row.created_at
              }}</span>
            </el-tooltip> -->
            <date-formatter :date-value="scope.row.created_at"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in col" :key="index" :prop="item.prop" :label="item.label"
          :width="tableColumn(item.prop)" :show-overflow-tooltip=item.tooltip>
          <template slot-scope="scope">
            <!-- <el-tooltip
              v-if="item.prop === 'custom_phone'"
              :content="scope.row.custom_phone + ''"
              placement="top"
            >
              <span class="count_style" style="display: inherit; width: 100px"
                ><el-link
                  style="color: #409eff; cursor: pointer"
                  @click="openPhoneFromDraw(scope.row.custom_phone)"
                  >{{
                    scope.row.custom_phone
                      ? scope.row.custom_phone.substring(0, 5) + "..."
                      : scope.row.custom_phone
                  }}</el-link
                >
                <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                  <i
                    @click="makePhone(scope.row.custom_phone)"
                    class="el-icon-phone-outline"
                    style="color: #409eff; cursor: pointer"
                  ></i>
                </el-tooltip>
              </span>
            </el-tooltip> -->
            <div v-if="item.prop === 'custom_phone'">
              <div v-if="scope.row.custom_phone && scope.row.custom_phone !== '****'">
                <phone-com :comPhone="scope.row.custom_phone" :vagaryPhone="scope.row.vagary_phone"
                  style="display: inline-block;" />
                <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                  <i @click="makePhone(scope.row.vagary_phone?scope.row.vagary_phone:scope.row.custom_phone)" class="el-icon-phone-outline"
                    style="color: #409eff; cursor: pointer"></i>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              <span class="count_style" style="display: inherit">{{
          scope.row[item.prop]
        }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="咨询关键内容" prop="refer_content" width="300">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.refer_content" placement="top">
              <span class="count_style">{{ scope.row.refer_content }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" v-if="false" label="操作" width="60">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="领取线索" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus"
                @click="handleEditOpen(scope.$index, scope.row.thread_id)" circle></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination background class="tr mt-10" layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-footer>

    <el-drawer title="线索录入" :visible.sync="addDrawer" direction="rtl" :before-close="handleAddDrawerBeforeClose"
      size="40%">
      <div class="m-tabs-content">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">线索信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="6" class="m-label">选择园区：</el-col>
          <el-col :span="10">
            <el-select v-model="addForm.garden" placeholder="请选择" :size="inputSize" clearable>
              <el-option :value="1" label="上海园区"></el-option>
              <el-option :value="2" label="南京园区"></el-option>
              <el-option :value="3" label="徐州园区"></el-option>
              <el-option :value="4" label="其他园区"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">线索状态：</el-col>
          <el-col :span="10">
            <el-select v-model="addForm.status" @change="selectStatus" placeholder="请选择" :size="inputSize" clearable>
              <el-option :value="1" label="跟踪中"></el-option>
              <el-option :value="4" label="成单待确认"></el-option>
              <el-option :value="3" label="无法联系"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">客户姓名：</el-col>
          <el-col :span="10"><el-input v-model="addForm.custom_name" :size="inputSize" clearable></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">客户手机：</el-col>
          <el-col :span="10"><el-input maxlength="11" v-model="addForm.custom_phone" :size="inputSize"
              clearable></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">微信号：</el-col>
          <el-col :span="10"><el-input v-model="addForm.wechat_account" :size="inputSize" clearable></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">所属省市：</el-col>
          <el-col :span="10">
            <el-cascader ref="cascaderAddr" style="width: 100%" v-model="value" :props="optionProps" :options="options"
              :size="inputSize" @change="handleChange"></el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">群聊ID：</el-col>
          <el-col :span="10"><el-input v-model="addForm.group_chat_id" :size="inputSize" clearable></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">页面标题：</el-col>
          <el-col :span="10"><el-input v-model="addForm.page_title" :size="inputSize" clearable></el-input></el-col>
        </el-row>

        <el-row v-show="addForm.status === 4">
          <el-col :span="6" class="m-label">转化人：</el-col>
          <el-col :span="10">
            <el-select :filterable="true" v-model="addForm.uid" placeholder="请选择" :size="inputSize" clearable>
              <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">咨询分类：</el-col>
          <el-col :span="10">
            <el-select v-model="addForm.refer_cate" placeholder="请选择" :size="inputSize" clearable>
              <el-option :value="1" label="云上注册"></el-option>
              <el-option :value="2" label="非云上注册"></el-option>
              <el-option :value="3" label="代理记账"></el-option>
              <el-option :value="4" label="公司注销"></el-option>
              <el-option :value="5" label="企业资质"></el-option>
              <el-option :value="6" label="公司变更"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">是否分配线索：</el-col>
          <el-col :span="10" class="m-label">
            <el-switch v-model="switchValue" :width="40" @change="switchChange" active-text="">
            </el-switch>
          </el-col>
        </el-row>
        <el-row v-show="addForm.type">
          <el-col :span="6" class="tr m-label text_right">公司分配:</el-col>
          <el-col :span="10">
            <el-select :filterable="true" v-model="addForm.uid" placeholder="请选择分配人员" size="mini" clearable>
              <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">咨询关键内容：</el-col>
          <el-col :span="18">
            <el-input style="min-height: 1rem" :autosize="textareaSize" type="textarea" v-model="addForm.refer_content"
              size="mini" clearable></el-input>
          </el-col>
        </el-row>
      </div>
      <el-row class="bottom-btn">
        <el-button @click="handleSave" size="mini" type="primary">保存</el-button>
      </el-row>
    </el-drawer>
    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible" class="el_dialogs" width="60%">
      <div class="box_title">
        <span>等级规则介绍</span>
        <i style="color: #4c87fc" class="el-icon-question"></i>
      </div>
      <div class="dialog_box">
        <p class="box_p">每周日晚上凌晨自动计算一次。</p>
        <p class="box_p">所在等级匹配相应仓位，</p>
        <p class="box_p">
          若是被降级，保持现有的线索，不能再领取，不能超过当前仓位，只能通过放弃到当前等级对应的仓位以下才能领取新线索。
        </p>
        <img src="../../assets/image/level.png" />
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <el-dialog title="选择分配人员" :visible.sync="dialogVisible2" width="25%">
      <div class="contents" style="margin-bottom: 0">
        <el-select style="width: 100%" :filterable="true" v-model="allotData.uid" placeholder="请选择分配人员" size="mini"
          clearable>
          <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose()">取 消</el-button>
        <el-button size="mini" type="primary" @click="HandleDialogVisible()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入线索" :visible.sync="dialogVisible3" width="25%">
      <div class="contents" style="margin-bottom: 0">
        <el-select style="width: 100%" @change="selectCluesType" v-model="clues_type" placeholder="请选择线索类型" size="mini"
          clearable>
          <el-option :value="1" label="IM套电"></el-option>
          <el-option :value="2" label="下单未支付"></el-option>
          <el-option :value="3" label="仅点快捷回复"></el-option>
          <el-option :value="4" label="仅IM咨询"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose2">取 消</el-button>
        <el-button v-show="uploadStatus === false" type="primary" size="mini"
          @click="HandleDialogVisible2">点击上传</el-button>
        <el-upload v-show="uploadStatus === true" style="display: inline-block; margin-left: 0.2rem"
          :action="actionHost + '/api/thread/excel'" :headers="uploadHeader" accept=".xls,.xlsx" :show-file-list="false"
          :data="{ input_type: clues_type }" :limit="1" :before-upload="beforeAvatarUpload" :on-success="handleImport">
          <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import img1 from "../../assets/image/qingtong.png";
import img2 from "../../assets/image/baiyin.png";
import img3 from "../../assets/image/huangjin.png";
import img4 from "../../assets/image/bojin.png";
import img5 from "../../assets/image/zuanshi.png";
import img6 from "../../assets/image/wangzhe.png";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import MakePhone from "common/MakePhone";
import DateFormatter from "common/DateFormatter";
import PhoneCom from 'common/PhoneCom'

export default {
  name: "TyCluePool",
  mixins: [fscDate],
  components: { MakePhone, DateFormatter, PhoneCom },
  props: {
    user: Object,
  },
  data() {
    return {
      activeOpen: "",
      phoneFrom_phone: [],
      phoneFromDraw: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      uploadStatus: false,
      multipleSelection: [],
      clues_type: "",
      switchValue: false,
      count: "",
      allotData: {
        uid: "",
        ids: [],
        username: "",
        status: [],
      },
      uploadHeader: { Authorization: localStorage.token },
      search: "",
      refer_cate: "",
      searchData: {},
      inputSize: "small",
      vipData: {},
      vipName: "",
      vipNum: 0,
      closeShow: false,
      value1: [],
      value: [3, 37],
      value2: [1, 2, 3, 4],
      value3: [3, 37],
      changHeightClass: "",
      pageNodes: [],
      highSearch: {
        group_chat_id: "",
        im_name: "",
        refer_cate: "",
        start_time: "",
        end_time: "",
        garden: "",
      },
      optionProps: {
        value: "id",
        label: "Provincial",
        children: "son",
      },
      textareaSize: { minRows: 6, maxRows: 10 },
      options: [],
      options2: [
        {
          value: 1,
          label: "IM套电",
        },
        {
          value: 2,
          label: "下单未支付",
        },
        {
          value: 3,
          label: "仅点快捷回复",
        },
        {
          value: 4,
          label: "仅IM咨询",
        },
      ],
      options3: [
        {
          value: 1,
          label: "云上注册",
        },
        {
          value: 2,
          label: "非云上注册",
        },
        {
          value: 3,
          label: "代理记账",
        },
        {
          value: 4,
          label: "公司注销",
        },
        {
          value: 5,
          label: "企业资质",
        },
        {
          value: 6,
          label: "公司变更",
        },
      ],
      options4: [
        {
          value: 1,
          label: "上海园区",
        },
        {
          value: 2,
          label: "南京园区",
        },
        {
          value: 3,
          label: "徐州园区",
        },
        {
          value: 6,
          label: "北京园区",
        },
        {
          value: 7,
          label: "天津园区",
        },
        {
          value: 8,
          label: "江苏园区",
        },
        {
          value: 9,
          label: "浙江园区",
        },
        {
          value: 10,
          label: "广东园区",
        },
        {
          value: 11,
          label: "江西园区",
        },
        {
          value: 12,
          label: "山东园区",
        },
        {
          value: 13,
          label: "山西园区",
        },
        {
          value: 14,
          label: "河南园区",
        },
        {
          value: 15,
          label: "河北园区",
        },
        {
          value: 16,
          label: "湖南园区",
        },
        {
          value: 17,
          label: "湖北园区",
        },
        {
          value: 18,
          label: "贵州园区",
        },
        {
          value: 19,
          label: "陕西园区",
        },
        {
          value: 20,
          label: "四川园区",
        },
        {
          value: 21,
          label: "安徽园区",
        },
      ],
      vipIcon: "",
      img: "",
      CluesPool: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      addDrawer: false,
      addForm: {
        garden: 1,
        status: 1,
        custom_name: "",
        custom_phone: "",
        wechat_account: "",
        custom_province: "",
        custom_city: "",
        custom_city_name: "",
        group_chat_id: "",
        page_title: "",
        im_name: "",
        refer_cate: 1,
        refer_content: "",
        conversion_people: "",
        uid: "",
        type: 0,
      },
      col: [
        {
          label: "客户姓名",
          prop: "custom_name",
          display: false,
        },
        {
          label: "所属省市",
          prop: "customer_city",
          display: false,
        },
        {
          label: "客户手机",
          prop: "custom_phone",
          display: false,
        },
        {
          label: "手机省份",
          prop: "phone_province",
          display: false,
          tooltip: true
        },
        {
          label: "微信号",
          prop: "wechat_account",
          display: false,
          tooltip: true
        },
        {
          label: "咨询分类",
          prop: "refer_cate",
          display: false,
        },
        {
          label: "群聊ID",
          prop: "group_chat_id",
          display: false,
          tooltip: true
        },
        {
          label: "页面标题",
          prop: "page_title",
          display: false,
        },
        {
          label: "IM人员",
          prop: "im_name",
          display: false,
        },
        {
          label: "园区",
          prop: "garden",
          display: false,
        },
      ],
      ConversionPeople: [],
      activeNames: ["1"],
      loading: [],
      values: "",
      startTime: "",
      endTime: "",
    };
  },
  computed: {
    pageData: function () {
      // var arr = this.CluesPool.filter(data => !this.search || data.custom_name.toLowerCase().includes(this.search.toLowerCase()) || data.custom_phone.toLowerCase().includes(this.search.toLowerCase())).slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
      // console.log(arr)
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          data.custom_name.toLowerCase().includes(this.search.toLowerCase()) ||
          data.custom_phone.toLowerCase().includes(this.search.toLowerCase())
      ).slice(
        this.pageOption.pageSize * (this.pageOption.currentPage - 1),
        this.pageOption.pageSize * this.pageOption.currentPage
      );
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development"
          ? "http://192.168.1.110"
          : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.CluesPool.length;
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  methods: {
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone);
      });
      this.phoneFromDraw = true;
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

      // if (!regPhone.test(phone)) {
      //   this.$message.error("手机号格式错误");
      //   return;
      // }

      // this.$axios.post("/api/admin/call_logs/" + phone).then((res) => {
      this.$axios
        .post("api/admin/call_logs_call", {
          phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("调用成功，请注意接听来电");
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = [];
      done();
    },
    tableColumn(prop) {
      let width = "";
      if (prop === "customer_city") {
        width = 200;
      } else if (prop === "custom_phone") {
        width = 175;
      }
      return width;
    },
    HandleDialogVisible2() {
      if (!this.clues_type) {
        this.$message.error("请先选择线索类型");
      }
    },
    selectCluesType(value) {
      let a = true;
      this.uploadStatus = value ? a : false;
    },
    HandleDialogVisibleClose2() {
      this.dialogVisible3 = false;
      this.uploadStatus = false;
      this.clues_type = "";
    },
    switchChange(value) {
      this.addForm.uid = value ? this.addForm.uid : "";
      this.addForm.type = value ? 1 : 0;
    },
    selectExport(val) {
      console.log(val);
    },
    selectType(val) {
      console.log(val);
    },
    pickerDataChange2(val) {
      if (!val) {
        this.startTime = "";
        this.endTime = "";
      } else {
        this.startTime = val[0];
        this.endTime = val[1];
      }
    },
    handleExport() {
      this.$axios
        .post(
          "/api/thread/otherout",
          {
            params: {
              start_time: this.startTime,
              end_time: this.endTime,
              input_types: this.value2,
            },
          },
          { responseType: "blob" }
        )
        .then((res) => {
          if (res.status === 205) {
            return;
          }
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "线索.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
          // window.location.href = objectUrl
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAddAllot() {
      if (this.multipleSelection.length) {
        this.dialogVisible2 = true;
        console.log(this.multipleSelection);
        for (var a = 0; a < this.multipleSelection.length; a++) {
          this.allotData.ids[a] = this.multipleSelection[a].thread_id;
          this.allotData.status[a] = this.multipleSelection[a].status;
        }
      } else {
        this.$message.error("请先选择要分配的线索");
      }
    },
    HandleDialogVisible() {
      this.ConversionPeople.forEach((item) => {
        if (item.id === this.allotData.uid) {
          this.allotData.username = item.username;
        }
      });
      this.$axios
        .post("/api/thread/get_batch_thread", {
          params: {
            uid: this.allotData.uid,
            ids: this.allotData.ids,
            username: this.allotData.username,
            status: this.allotData.status,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.handelGetOrders();
            this.dialogVisible2 = false;
            if (this.index === 0) this.prePage();
          } else {
            this.$message.error(data.msg);
            this.handelGetOrders();
            this.dialogVisible2 = false;
          }
        });
    },
    HandleDialogVisibleClose() {
      this.dialogVisible2 = false;
    },
    groupInput(val) {
      this.highSearch.group_chat_id = val;
    },
    handleSearch() {
      this.activeOpen = "";
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.im_name,
        this.highSearch.refer_cate,
        this.highSearch.start_time,
        this.highSearch.end_time,
        this.highSearch.garden
      );
    },
    handleCloseSearch() {
      this.highSearch.group_chat_id = "";
      this.highSearch.im_name = "";
      this.highSearch.refer_cate = "";
      this.highSearch.garden = "";
      this.value1 = [];
      this.highSearch.start_time = "";
      this.highSearch.end_time = "";
      this.activeOpen = "";
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.im_name,
        this.highSearch.refer_cate,
        this.value1,
        this.value1,
        this.highSearch.garden
      );
    },
    handleChangeHeight(val) { },
    getVipCluesNum() {
      this.$axios.get("/api/thread/statistics").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.vipData = data.data;
          this.vipName = this.vipGradeMethods(data.data.level);
          this.img = this.vipGradeIconMethods(data.data.level);
        }
      });
    },
    vipGradeIconMethods(key) {
      let vipData = [" ", img1, img2, img3, img4, img5, img6];
      return vipData[key];
    },
    vipGradeMethods(key) {
      let vipData = [" ", "青铜", "白银", "黄金", "铂金", "钻石", "最强王者"];
      return vipData[key];
    },
    gardenMethods(key) {
      let vipData = [" ", "上海园区", "南京园区", "徐州园区"];
      return vipData[key];
    },
    // handelGetOrders (groupChatId, imName, referCate, startTime, endTime, Garden) {
    //   this.$axios.get('/api/thread/otherlist', {
    //     params: {
    //       group_chat_id: groupChatId,
    //       im_name: imName,
    //       refer_cate: referCate,
    //       start_time: startTime,
    //       end_time: endTime,
    //       garden: Garden
    //     }
    //   })
    //     .then((res) => {
    //       const { data } = res
    //       if (data.code === 0) {
    //         this.CluesPool = data.data.list
    //         //
    //         this.pageNodes = data.data.pageNodes
    //         this.count = data.data.count
    //         this.ConversionPeople = data.data.users
    //         for (var a = 0; a < this.CluesPool.length; a++) {
    //           this.CluesPool[a].refer_cate = this.refer_cateMethods(this.CluesPool[a].refer_cate)
    //           this.CluesPool[a].garden = this.gardenMethods(this.CluesPool[a].garden)
    //           this.CluesPool[a].customer_city = this.CluesPool[a].custom_city_name
    //         }
    //         this.pageOption.total = data.data.count
    //       }
    //     })
    // },
    handelGetOrders(groupChatId, imName, referCate, startTime, endTime, Garden) {
      this.$axios
        .get(
          "/api/thread/otherlist?page=" +
          this.pageOption.currentPage +
          "&perPage=" +
          this.pageOption.pageSize,
          {
            params: {
              group_chat_id: groupChatId,
              im_name: imName,
              refer_cate: referCate,
              start_time: startTime,
              end_time: endTime,
              garden: Garden,
            },
          }
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.CluesPool = data.data.list.data;
            //
            this.pageNodes = data.data.pageNodes;
            this.count = data.data.count;
            this.ConversionPeople = data.data.users;
            for (var a = 0; a < this.CluesPool.length; a++) {
              this.CluesPool[a].refer_cate = this.refer_cateMethods(
                this.CluesPool[a].refer_cate
              );
              this.CluesPool[a].garden = this.gardenMethods(this.CluesPool[a].garden);
              this.CluesPool[a].customer_city = this.CluesPool[a].custom_city_name;
            }
            this.pageOption.total = data.data.list.total;
          }
        });
    },
    provinceCityData() {
      this.$axios.get("/api/thread/cities").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var a = 0; a < data.data.length; a++) {
            this.options.push(data.data[a]);
          }
        }
      });
    },
    refer_cateMethods(key) {
      let vipData = [
        " ",
        "云上注册",
        "非云上注册",
        "代理记账",
        "公司注销",
        "企业资质",
        "公司变更",
      ];
      return vipData[key];
    },
    pickerDataChange(val) {
      if (!val) {
        this.highSearch.start_time = "";
        this.highSearch.end_time = "";
      } else {
        this.highSearch.start_time = val[0];
        this.highSearch.end_time = val[1];
      }
    },
    searchTotal() {
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          data.custom_name.toLowerCase().includes(this.search.toLowerCase())
      ).length;
    },
    // handleSizeChange (val) {
    //   this.pageOption.pageSize = val
    // },
    // handleCurrentChange (val) {
    //   this.pageOption.currentPage = val
    // },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      // this.handelGetOrders()
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      // this.handelGetOrders()
      this.handleSearch();
    },
    handelSetValue() {
      for (var i = 0; i <= this.col.length; i++) {
        this.value1.push(i);
      }
    },
    handleChangeSearch(value) {
      let input = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.highSearch.custom_city_name = input[0] + "/" + input[1];
    },
    handleChange(value) {
      let input = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.addForm.custom_city_name = input[0] + "/" + input[1];
      this.addForm.custom_province = value[0];
      this.addForm.custom_city = value[1];
    },
    handleAddOpen() {
      let that = this;
      that.addDrawer = true;
      that.addForm.custom_city_name = "上海市" + "/" + "上海市";
      that.addForm.custom_province = that.value[0];
      that.addForm.custom_city = that.value[1];
      that.addForm.refer_cate = 1;
    },
    selectStatus(val) {
      if (val === 4) {
        for (var a = 0; a < this.ConversionPeople.length; a++) {
          if (this.ConversionPeople[a].id === this.user.id) {
            this.addForm.uid = this.ConversionPeople[a].id;
          }
        }
      } else {
        this.addForm.uid = "";
      }
    },
    handleAddDrawerBeforeClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => { });
    },
    handleAddDrawerClose() {
      this.addDrawer = false;
      this.clearAddData();
    },
    clearAddData() {
      this.addForm.status = 1;
      this.addForm.custom_name = "";
      this.addForm.custom_phone = "";
      this.addForm.wechat_account = "";
      this.addForm.im_name = "";
      this.addForm.page_title = "";
      this.addForm.group_chat_id = "";
      this.addForm.refer_cate = "";
      this.addForm.refer_content = "";
      this.addForm.uid = "";
      this.switchValue = false;
      this.addForm.type = 0;
    },
    handleSave() {
      let phone = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (!this.addForm.custom_phone && !this.addForm.wechat_account) {
        this.$message.error("客户手机或微信号不能为空");
        return;
      }
      if (this.addForm.custom_phone !== "") {
        if (!phone.test(this.addForm.custom_phone)) {
          this.$message.error("客户手机号格式不正确");
          return;
        }
      }
      if (!this.addForm.custom_province) {
        this.$message.error("请选择所属省市");
        return;
      }
      if (!this.addForm.group_chat_id) {
        this.$message.error("群聊ID不能为空");
        return;
      }
      if (this.addForm.status === 2) {
        if (!this.addForm.uid) {
          this.$message.error("转化人不能为空");
          return;
        }
      }
      if (!this.addForm.refer_cate) {
        this.$message.error("请选择咨询分类");
        return;
      }
      if (!this.addForm.refer_content) {
        this.$message.error("咨询关键内容不能为空");
        return;
      }
      let that = this;
      this.$axios.post("/api/thread/imcreate", that.addForm).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          if (!that.addForm.uid) {
            data.data[0].refer_cate = that.refer_cateMethods(data.data[0].refer_cate);
            data.data[0].garden = that.gardenMethods(data.data[0].garden);
            that.CluesPool.unshift(data.data[0]);
            that.CluesPool[0].customer_city = data.data[0].custom_city_name;
          }
          that.getVipCluesNum();
          that.pageOption.total = that.pageOption.total + data.data.length;
          that.handleAddDrawerClose();
          that.$message.success(data.msg);
        } else {
          that.$message.error(data.msg);
        }
      });
    },
    handleEditOpen(index, id) {
      this.getClues(index, id);
    },
    getClues(index, id) {
      this.$axios.get("/api/thread/getthread/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
          this.CluesPool.splice(idx, 1);
          this.pageOption.total = this.CluesPool.length;
          this.getVipCluesNum();
          this.$notify({
            title: "成功",
            message: "线索领取成功",
            type: "success",
          });
          if (index === 0) this.prePage();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    handleUpdateClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearUpdateData();
          done();
        })
        .catch((_) => { });
    },
    handleImport(res, file) {
      if (res.code === 0) {
        this.$message.success(res.msg);
        this.loading.close();
        this.handelGetOrders();
        this.dialogVisible3 = false;
        this.uploadStatus = false;
        this.clues_type = "";
      }
    },
    beforeAvatarUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
  mounted() {
    this.provinceCityData();
    this.handelGetOrders();
    this.getVipCluesNum();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-date-editor
  width: 100% !important
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.clue-pool
  marginLeft()
  max-height: 100vh
  .header-style
    z-index: 2
    height: 135px !important
    padding: 0px !important
  .main-style
    z-index: 1
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 15px
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .icon-qingtonghuiyuan
    color: #E9935D;
  .icon-baiyinhuiyuan
    color: #E6E8FA
  .icon-huangjinhuiyuan
    color: #FFD32F;
  .icon-qingtong
    color: #40BBEC
  .icon-zuanshi
    color: #83A4FF;
  .icon-wangzhe
    color: #A8A8A8
.mb-10
  margin-bottom: .2rem
  margin-top .4rem
.mt-10
  margin-top: .2rem
.level
  display flex
  align-items center
  position relative
  padding-right .32rem
  img
    width .32rem
    height .30rem
  .el-icon-question
    margin-left: .1rem
    color: #409EFF
    position absolute
    top 0
    right 0
    cursor pointer
.count
  padding-left: .2rem
  line-height: .56rem
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .tabs_line
    display flex
    .lines
      width .06rem
      height .30rem
      background #4C87FC
      margin-right .1rem
    .tabs-title
      color: #000000
      font-weight bold
  .m-label
    line-height: .56rem
  .text_right
    text-align left
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.changeHeight
  padding 0
  margin-top .4rem
.clue-pool >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.bottom-btn
  padding: .2rem
  text-align: right
.el-position
  position relative
.dot
  display inline-block
  width 0.1rem
  height 0.1rem
  border-radius 50%
  margin-right 0.1rem
  position absolute
  top 0
  left -.2rem
  bottom 0
  margin auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-collapse >>> .el-collapse-item__content
  padding-bottom 0
.el_dialogs >>> .el-dialog__body
  padding-left 0
  padding-right 0
.el_dialogs >>> .el-dialog__header
  padding 0
.box_title
  margin-bottom .4rem
  padding-left .6rem
  span
    font-size 0.32rem
    color: #333
    font-weight bold
.dialog_box
  padding-left 1.45rem
  padding-right 1.45rem
  .box_p
    font-size .28rem
    line-height .7rem
    color: #666666
  img
    width 100%
    margin-top .4rem
.contents
  margin-bottom .4rem
  .dialog-footer
    display block
    position: absolute;
    right .4rem
    bottom .2rem
</style>



// WEBPACK FOOTER //
// src/pages/other_clues/other_clues.vue